import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import { Accordion, Card, Button } from 'react-bootstrap'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'
import { getAllCMSPagesAsync, getEmissionDetails } from '../_redux'
import { Faq } from './Faq'
import { EmissionDiagram } from '../../../../_metronic/_assets/js/components/emissionProgressDiag'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.2) !important',
  },
}))

function HomePage() {
  const classes = useStyles()
  const [goldData, setGoldData] = useState(null)
  const [tokenData, setTokenData] = useState(null)

  const { CMS, backdrop, emissionData } = useSelector(
    (state) => state.auth,
    shallowEqual,
  )

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllCMSPagesAsync())
    dispatch(getEmissionDetails())
  }, [])

  useEffect(() => {
    if (emissionData) {
      setGoldData([
        {
          category: 'Sold',
          amount: +emissionData.currentGoldAmountSold / 1000,
        },
        {
          category: 'Remaining',
          amount: (3020000 - +emissionData.currentGoldAmountSold) / 1000,
        },
      ])
      setTokenData([
        {
          category: 'Sold',
          amount: +emissionData.currentAllocatedTokens,
        },
        {
          category: 'Remaining',
          amount: 40000000 - +emissionData.currentAllocatedTokens,
        },
      ])
    }
  }, [emissionData])

  return (
    <>
      <div className="bg-white">
        <div className="hm_sc_1 mrgn_tp_130">
          <div className="container container_frnt">
            <div className="row flex-row-reverse align-items-end">
              <div className="col-md-6 text-center">
                <img
                  alt=""
                  src={toAbsoluteUrl('/media/logos/gold-bar.jpg')}
                  className="img-fluid gold-bar-img"
                />
              </div>
              <div className="col-md-6 pt_m_30 text-center">
                <img
                  alt="logo"
                  className="pb-6 w-100"
                  src={toAbsoluteUrl('/media/logos/logo-light.svg')}
                />
                <h1 className="def_hdng_v1 mx550">
                  The Golden <span className="grbg_rndd">Guarantee.</span>
                </h1>
                {/* <div className="pl-10"> */}
                {/* <h6 className="wt_lft_brdr fn_s_20 f-w-400 color_blk mb-8">
                    Nullam congue mattis purus curabitur dapibus ullamcorper
                    erat facilisis lectus dictum non.
                  </h6> */}

                <p className="def_p_v2 mb-10">
                  QRFID-GOLD offers a digitally secure, decentralized and
                  value-based alternative to a store of wealth assets for any
                  individual in the form of investment grade physical gold,
                  without prejudice and free from the confines of traditional
                  storage and banking fees.
                </p>
                {/* </div> */}
                {/* <Link to="#" className="btn btn-def defwtarw">
                  <span>Call to Action</span>
                </Link> */}
              </div>
            </div>
          </div>
        </div>
        <div className="hm_sc_2 mrgn_tp_130">
          <div className="container container_frnt">
            <div className="row d-flex align-items-center">
              <div className="col-lg-5 sc_1_lf">
                <img
                  alt=""
                  src={toAbsoluteUrl('/media/others/abt_img_1.jpg')}
                  className="img-fluid"
                />
              </div>
              <div className="col-lg-7">
                {/* <h5 className="df_h5"> QRFID GOLD</h5> */}
                <h2 className="def_hdng_v1 mx550 mb-8">
                  About <span className="grbg_rndd">QRFID-GOLD</span>
                </h2>
                <p className="def_p_v2 mx550 mb-10">
                  QRFID-GOLD digitizes investment grade gold using an ERC1400
                  standard Smart Contract on the Ethereum Blockchain and offers
                  several levels of security to ensure real value behind this
                  cryptocurrency.
                </p>
                <ul className="abtinf_lst">
                  <li>
                    <i className="fas fa-check-circle"></i> Real gold attached
                    to each Token, providing real and measurable value unlike
                    the majority of cryptocurrencies
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> A viable up-to-date
                    alternative to fiat currencies to avoid inflationary
                    problems
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> No storage fees
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> A decentralized
                    system allowing QRFID-GOLD Token holders to easily buy and
                    send Tokens without the expense and time needed in
                    conventional banking systems
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> Tamper-proof
                    QRFID-tagged gold bars connected to the blockchain to ensure
                    constant monitoring
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> Swiss notarized
                    processes guaranteeing realtime proof of value of each coin
                    (token)
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> All gold is stored
                    in a high-security Swiss bunker and duly insured
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> Direct ownership and
                    transparency along with blockchain anonymity for every owned
                    token
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> Token emission
                    process can never take place before physical gold has been
                    physically incorporated into the blockchain, meaning each
                    token has full value without debt or leveraging
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> Live camera feeds
                    proving the existence and constant addition of gold to the
                    blockchain
                  </li>
                </ul>
                {/* <Link to="#" className="btn btn-def defwtarw">
                  <span>Call to Action</span>
                </Link> */}
              </div>
            </div>
          </div>
        </div>
        <div className="hm_sc_3 mrgn_tp_130">
          <div className="container container_frnt">
            <div className="bl_box">
              <div className="row d-flex align-items-end">
                <div className="col-md-7 sc_1_lf">
                  {/* <h5 className="df_h5 df_h5_x_l_prpl">QRFID Gold Solution</h5> */}
                  <h2 className="def_hdng_v1 def_l_hdng_v1 mx550">
                    QRFID-GOLD
                    <span className="prplbg_rndd ml-3">Solution</span>
                  </h2>
                  <p className="def_p_v2 mx550 mb-10 color_wht">
                    QRFID-GOLD is the sole emitter of all the Tokens that are
                    individually connected to physical gold stored in a secure
                    Swiss bunker. Each token is based on a linear price increase
                    peremission.
                  </p>
                  <p className="def_p_v2 mx550 mb-10 color_wht">
                    The starting Token is equal to 0.001g of gold, and increases
                    by 0.000000003725g per token emitted thereafter. There are a
                    total of 40 million Tokens able to be emitted in this
                    algorithm, resulting in the last token having a worth of
                    0.15g of gold.
                  </p>
                  <p className="def_p_v2 mx550 mb-10 color_wht">
                    Each emitted Token always has the same coverage of gold
                    behind it relative to the total stock in storage. This means
                    that with each new Token emission the coverage of each Token
                    in circulation increases fractionally, each Token
                    representing the exact weight of total gold in storage
                    divided by the total amount of Tokens in circulation at the
                    time. In essence, each Token increases steadily in gold
                    weight with every emission leading to each Token have a
                    steadily higher emission price.
                  </p>
                  <p className="def_p_v2 mx550 color_wht">
                    Once the last token has been emitted, QRFID-GOLD will
                    stabilize in price and be a fully-fledged Stablecoin
                    directly reflecting the changes in the world gold bullion
                    market price.
                  </p>
                  {/* <Link to="#" className="btn btn-def-v2 defwtarwv2">
                    <span>Call to Action</span>
                  </Link> */}
                </div>
                <div className="col-md-5 sc_3_rt">
                  <img
                    alt=""
                    src={toAbsoluteUrl('/media/others/abt_img_3.png')}
                    className="img-fluid "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hm_sc_1 mrgn_tp_130">
          <div className="container container_frnt">
            <h1 className=" text-center def_hdng_v1">
              <span className="grbg_rndd">Emission</span> Progress
            </h1>
            {goldData ? (
              <EmissionDiagram tokenData={tokenData} goldData={goldData} />
            ) : (
              <div className="text-center">Loading...</div>
            )}
          </div>
        </div>
        {/* <div className="hm_sc_4 mrgn_tp_130">
          <div className="container container_frnt">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h5 className="df_h5">About QRFID GOLD</h5>
                    <h2 className="def_hdng_v1 mb-8 ml-auto mr-auto">
                      <span className="grbg_rndd">Quisque tempus</span> pretium
                      pharetra
                    </h2>
                    <p className="def_p_v2 mx680 mb-10 ml-auto mr-auto">
                      Maecenas id leo eleifend lorem ultricies fermentum. Mauris
                      sed massa sit amet ex odio. Curabitur ac libero vitae est
                      viverra posuere. Nunc placerat pulvinar malesuada.
                    </p>
                  </div>
                  <div className="col-md-4 text-center">
                    <div className="sc4_wt_bx">
                      <div className="sc_4_img">
                        <img
                          alt=""
                          src={toAbsoluteUrl(
                            "/media/others/priceofgold_ic.jpg"
                          )}
                          className="img-fluid mt-4"
                        />
                      </div>
                      <h4 className="l-700 fn_s_18 color_blue mb-4">
                        Price of Gold
                      </h4>
                      <p className="l-400 fn_s_18 color_blk opacity70">
                        Sed massa lorem amet curabitur placerat pulvinar
                        malesuada.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center sc_4_rs_mrgn">
                    <div className="sc4_wt_bx">
                      <div className="sc_4_img">
                        <img
                          alt=""
                          src={toAbsoluteUrl(
                            "/media/others/totalavailablegold_ic.jpg"
                          )}
                          className="img-fluid mt-4"
                        />
                      </div>
                      <h4 className="l-700 fn_s_18 color_blue mb-4">
                        Total Available Gold
                      </h4>
                      <p className="l-400 fn_s_18 color_blk opacity70">
                        Sed massa lorem amet curabitur placerat pulvinar
                        malesuada.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div className="sc4_wt_bx">
                      <div className="sc_4_img">
                        <img
                          alt=""
                          src={toAbsoluteUrl("/media/others/livestream_ic.jpg")}
                          className="img-fluid mt-4"
                        />
                      </div>
                      <h4 className="l-700 fn_s_18 color_blue mb-4">
                        Livestream
                      </h4>
                      <p className="l-400 fn_s_18 color_blk opacity70">
                        Sed massa lorem amet curabitur placerat pulvinar
                        malesuada.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="hm_sc_5 mrgn_tp_130" id="Feature">
          <div className="container container_frnt">
            <div className="sc_5_bx">
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      {/* <h5 className="df_h5">Platform feature</h5> */}
                      <h2 className="def_hdng_v1 mb-8 ml-auto mr-auto">
                        Platform <span className="grbg_rndd">Feature</span>
                      </h2>
                    </div>
                    <div className="col-md-12 mb-15">
                      <img
                        alt=""
                        src={toAbsoluteUrl('/media/others/feature_img.jpg')}
                        className="img-fluid mt-4"
                      />
                    </div>
                    <div className="col-md-12">
                      <div className="sc_5_inn">
                        <div className="row d-flex align-items-center">
                          <div className="col-md-3">
                            <img
                              alt=""
                              src={toAbsoluteUrl('/media/others/sc_5_i1.svg')}
                              className="img-fluid ml-md-5 sc5_m_b"
                            />
                          </div>
                          <div className="col-md-9">
                            {/* <h6 className="f-w-500 fn_s_18 color_blk">
                              Phasellus non risus tristique interdum
                            </h6> */}
                            <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                              Buy your QRFID-GOLD Tokens directly by registering
                              and completing the simple KYC process here. As a
                              registered User, you will be able to buy directly
                              from the source before being able to trade Tokens
                              with anyone using an ERC compliant wallet on the
                              Ethereum Blockchain.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="sc_5_inn">
                        <div className="row flex-row-reverse align-items-center">
                          <div className="col-md-3 text-right">
                            <img
                              alt=""
                              src={toAbsoluteUrl('/media/others/sc_5_i2.svg')}
                              className="img-fluid mr-md-5 sc5_m_b"
                            />
                          </div>
                          <div className="col-md-9">
                            {/* <h6 className="f-w-500 fn_s_18 color_blk">
                              Phasellus non risus tristique interdum
                            </h6> */}
                            <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                              Your QRFID-Gold account is your portal to buying
                              your Tokens whilst simultaneously ensuring you
                              have complete control over your own wallet in no
                              way accessible by QRFID-GOLD, unlike many of the
                              exchanges which simply apportion you a part of
                              their own single wallet according to the
                              percentage of you hold within it.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="sc_5_inn">
                        <div className="row d-flex align-items-center">
                          <div className="col-md-3">
                            <img
                              alt=""
                              src={toAbsoluteUrl('/media/others/sc_5_i3.svg')}
                              className="img-fluid ml-md-5 sc5_m_b"
                            />
                          </div>
                          <div className="col-md-9">
                            {/* <h6 className="f-w-500 fn_s_18 color_blk">
                              Phasellus non risus tristique interdum
                            </h6> */}
                            <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                              Initially, all users will need to register using a
                              MetaMask wallet as guided during the registration
                              process that will be automatically linked to the
                              QRFID account. This wallet can be accessed by the
                              user’s computer or mobile phone to facilitate easy
                              access at all times whilst providing secure and
                              sole access to the User.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="sc_5_inn">
                        <div className="row flex-row-reverse align-items-center">
                          <div className="col-md-3 text-right">
                            <img
                              alt=""
                              src={toAbsoluteUrl('/media/others/sc_5_i4.svg')}
                              className="img-fluid mr-md-5 sc5_m_b"
                            />
                          </div>
                          <div className="col-md-9">
                            {/* <h6 className="f-w-500 fn_s_18 color_blk">
                              Phasellus non risus tristique interdum
                            </h6> */}
                            <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                              The QRFID-GOLD Smart Contract is based on the
                              ERC1400 standard, which is simply a more extended
                              version of ERC20 as a larger amount of information
                              is needed to be stored for each Token code that
                              makes up the blockchain. Using this standard
                              allows for more stable and faster transaction
                              speeds in anticipation for when the Tokens are
                              openly traded on crypto-exchanges.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-12 text-center sc_5_bttm">
                      <p className="def_p_v2 mx550 mb-10 ml-auto mr-auto mt-10">
                        Maecenas id leo eleifend lorem ultricies fermentum.
                        Mauris sed massa sit amet ex odio. Curabitur ac libero
                        vitae est viverra posueren unc placerat.
                      </p>
                      <Link to="#" className="btn btn-def defwtarw">
                        <span>Call to Action</span>
                      </Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hm_sc_6 mrgn_tp_70 RoadmapSec">
          <div className="container container_frnt">
            <div className="row">
              <div className="col-md-12 text-center mb-10">
                {/* <h5 className="df_h5">Roadmap</h5> */}
                <h2 className="def_hdng_v1 mb-8 ml-auto mr-auto">Roadmap</h2>
              </div>
              <div className="col-lg-4 sc_6_b_1 text_m_center">
                <div className="sc_6_cntn sc_6_cntn_v1">
                  <div className="sc_6_cntr">1</div>
                  <h6 className="f-w-500 fn_s_18 color_blk">
                    Initial Release - Founders and Friends + Family
                  </h6>
                  {/* <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                    Nunc consequat rutrum eleifend sem feugiat metus, tincidunt
                    vestib neque ut tortor facilisis dapibus.
                  </p> */}
                </div>
                <div className="sc_6_cntn sc_6_cntn_v1">
                  <div className="sc_6_cntr">2</div>
                  <h6 className="f-w-500 fn_s_18 color_blk">
                    Preferred Investors
                  </h6>
                  {/* <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                    Nunc consequat rutrum eleifend sem feugiat metus, tincidunt
                    vestib neque ut tortor facilisis dapibus.
                  </p> */}
                </div>
              </div>
              <div className="col-lg-4 sc_6_b_2 text_m_center">
                <div className="sc_6_cntn sc_6_cntn_v3">
                  <div className="sc_6_cntr">3</div>
                  <h6 className="f-w-500 fn_s_18 color_blk">
                    Open Market to registered QRFID-GOLD users
                  </h6>
                  {/* <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                    Nunc consequat rutrum eleifend sem feugiat metus, tincidunt
                    vestib neque ut tortor facilisis dapibus.
                  </p> */}
                </div>
                <div className="sc_6_cntn sc_6_cntn_v2">
                  <div className="sc_6_cntr">4</div>
                  <h6 className="f-w-500 fn_s_18 color_blk">
                    QRFID-GOLD traded on 3rd Party Crypto Exchanges
                  </h6>
                  {/* <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                    Nunc consequat rutrum eleifend sem feugiat metus, tincidunt
                    vestib neque ut tortor facilisis dapibus.
                  </p> */}
                </div>
              </div>
              <div className="col-lg-4 sc_6_b_3 text_m_center">
                <div className="sc_6_cntn sc_6_cntn_v4">
                  <div className="sc_6_cntr">5</div>
                  <h6 className="f-w-500 fn_s_18 color_blk">
                    40 millionth Token is emitted, QRFID-GOLD becomes a
                    fully-fledged Stablecoin
                  </h6>
                  {/* <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                    Nunc consequat rutrum eleifend sem feugiat metus, tincidunt
                    vestib neque ut tortor facilisis dapibus.
                  </p> */}
                </div>
                <div className="sc_6_cntn sc_6_cntn_v5">
                  <div className="sc_6_cntr">6</div>
                  <h6 className="f-w-500 fn_s_18 color_blk">
                    2nd Stage - 0.5% to 0.8% of additional tokens are emitted to
                    control inflationary/ deflationary movements using a
                    separate Smart Contract to follow on from the original.
                  </h6>
                  {/* <p className="f-w-400 fn_s_16 color_blk opacity60 mb-0">
                    Nunc consequat rutrum eleifend sem feugiat metus, tincidunt
                    vestib neque ut tortor facilisis dapibus.
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hm_sc_6 mrgn_tp_130" id="team">
          <div className="container container_frnt">
            <div className="row">
              <div className="col-md-12 text-center mb-10">
                {/* <h5 className="df_h5">team members</h5> */}
                <h2 className="def_hdng_v1 mb-8 ml-auto mr-auto">
                  Team <span className="grbg_rndd">Members</span>
                </h2>
              </div>
              <div className="col-md-12 text-center">
                <ul className="tst_lists">
                  <li>
                    <img
                      alt="Co-funder one photo"
                      src={toAbsoluteUrl('/media/client-logos/Photo2.jpeg')}
                      className="img-fluid w-200px radius-circle"
                    />
                    <div className="mt-6">
                      <img
                        alt="Co-funder one name"
                        style={{ height: '27px' }}
                        src={toAbsoluteUrl('/media/client-logos/Photo4.png')}
                      />
                    </div>
                    {/* <h4>Sebastian A. S. Strassburg</h4> */}
                    <p>Co-Founder</p>
                  </li>
                  <li>
                    <img
                      alt="Co-founder two photo"
                      src={toAbsoluteUrl('/media/client-logos/Photo1.jpeg')}
                      className="img-fluid w-200px radius-circle"
                    />
                    <div className="mt-6">
                      <img
                        alt="Co-funder two name"
                        style={{ height: '27px' }}
                        src={toAbsoluteUrl('/media/client-logos/Photo3.png')}
                      />
                    </div>
                    {/* <h4>Michele Colaci</h4> */}
                    <p>Co-Founder</p>
                  </li>
                  {/* <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                      className="img-fluid w-200px"
                    />
                    <h4>Michele Colaci</h4>
                    <p>Head Of Asia</p>
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                      className="img-fluid w-200px"
                    />
                    <h4>Malkhaz Tavartkiladze</h4>
                    <p>Head Of Operations</p>
                  </li> */}
                  {/* <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/user1.png")}
                      className="img-fluid"
                    />
                    <h4>Andrew McLead</h4>
                    <p>Designation Here</p>
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/user2.png")}
                      className="img-fluid"
                    />
                    <h4>Bana Mathew</h4>
                    <p>Designation Here</p>
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/user1.png")}
                      className="img-fluid"
                    />
                    <h4>Andrew McLead</h4>
                    <p>Designation Here</p>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="hm_sc_7 mrgn_tp_130">
          <div className="container container_frnt">
            <div className="sc_7_bx">
              <div className="row">
                <div className="col-md-12 text-center mb-10">
                  <img
                    alt=""
                    src={toAbsoluteUrl('/media/others/dwnld_img.png')}
                    className="img-fluid sc_7_img"
                  />
                  <h2 className="def_hdng_v1 def_l_hdng_v1">
                    <span className="prplbg_rndd">Download</span> Documents
                  </h2>
                  <a
                    href="https://qrfid-public-documents.s3.us-east-2.amazonaws.com/QRFID-Whitepaper(Live).pdf"
                    target="_blank"
                    download="QRFID-Whitepaper"
                    className="btn btn-def-v2 defwtarwv3 mx-3 mb-2"
                  >
                    <span>Whitepaper</span>
                  </a>
                  <a
                    href="https://qrfid-public-documents.s3.us-east-2.amazonaws.com/QRFID-Business-Model.pdf"
                    target="_blank"
                    download="Business-Model"
                    className="btn btn-def-v2 defwtarwv3 mx-3 mb-2"
                  >
                    <span>Business Model</span>
                  </a>
                  <a
                    href="https://qrfid-public-documents.s3.us-east-2.amazonaws.com/QRFID-Tokenomics.pdf"
                    target="_blank"
                    download="QRFID-Tokenomics"
                    className="btn btn-def-v2 defwtarwv3 mx-3 mb-2"
                  >
                    <span>Tokenomics</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hm_sc_6 mrgn_tp_80">
          <div className="container container_frnt">
            <div className="row justify-content-center">
              <div className="col-md-12 text-center mb-10 mb-m-05">
                <h2 className="def_hdng_v1 mb-0 ml-auto mr-auto">
                  <span className="grbg_rndd">Frequently</span> Asked Questions
                </h2>
              </div>
              <div className="col-md-12">
                <Faq />
                {/*<div className="faq_bx">
                   <Accordion>
                    {CMS.FAQ && CMS.FAQ.FAQs
                      ? CMS.FAQ.FAQs.map((faq, i) => (
                          <Card key={faq._id}>
                            <Card.Header>
                              <Accordion.Toggle
                                as={Button}
                                variant="link"
                                eventKey={i}
                              >
                                <i className="fas fa-caret-right"></i>
                                <span
                                  className="faq_txt"
                                  dangerouslySetInnerHTML={{
                                    __html: faq.question,
                                  }}
                                ></span>
                                <span className="mrbtn">MORE</span>
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey={i}>
                              <Card.Body
                                dangerouslySetInnerHTML={{ __html: faq.answer }}
                              ></Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        ))
                      : null}
                  </Accordion> 
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backdrop className={classes.backdrop} open={backdrop}>
        <CircularProgress color="primary" />
      </Backdrop>
    </>
  )
}

export default HomePage
